import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ApiService } from 'src/app/api.service'; // Adjust path as per your project structure
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboarding-status',
  templateUrl: './onboarding-status.component.html',
  styleUrls: ['./onboarding-status.component.scss']
})
export class OnboardingStatusComponent implements OnInit {
  customerId: string = localStorage.getItem('leadId') || '';
  status: any = null; 
  isLoading: boolean = false;
  errorMessage: string | null = null;

  constructor(private api: ApiService, private router: Router) {}

  ngOnInit() {
    if (!this.customerId) {
      this.router.navigate(['/onboarding']); 
      return;
    }
    this.fetchStatus();
  }




  fetchStatus() {
    this.isLoading = true;
    this.errorMessage = null;
    this.api.getOnboardingStatus(this.customerId).subscribe({
      next: (res: any) => {
        this.status = res; // Store the response
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error('Failed to fetch status:', err);
        this.isLoading = false;
        this.errorMessage = 'Unable to verify your status. Please try again.';
      }
    });
  }

  retry() {
    this.fetchStatus();
  }

}